import { createV3Queries } from "@query/utils/createV3Queries";
import { batchesApi } from "@api";

/**
 * Bulk-operation batches (`/v3/platform/batches`) — the v3 twin of the v1
 * bulk-importer batch collections.
 *
 * `listBatches` filters server-side on `type` (required inside `filter`),
 * `status`, `accountId` and an inclusive `createdAt` range, and pages on an
 * opaque token. It offers no `sort`, so a screen that wants one has to page the
 * whole collection with `useQueryAll` and order client-side.
 */
export const queriesBatches = createV3Queries("batchesApi", batchesApi);
